<div id="app" class="app h-100"> 
    <router-outlet></router-outlet> 
    <ng-progress [spinner]="true" [meteor]="false" color="#388e3c"></ng-progress> 
</div>